import { jsx as _jsx } from "react/jsx-runtime";
import { useParams } from 'react-router-dom';
import { PricingTab } from '../../PricingTab';
export function SourcesPricingPage() {
    const { id } = useParams();
    if (!id) return null;
    return /*#__PURE__*/ _jsx("div", {
        className: "p-4 sm:p-6 lg:p-8",
        children: /*#__PURE__*/ _jsx(PricingTab, {
            projectId: id
        })
    });
}
